import { Dialog, DialogProps, paperClasses } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { BlueRoundedButton } from '../BlueRoundedButton';

const SuccessModalContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  width: 575px;
  height: 200px;
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1;
  box-sizing: border-box;
  border: 1px solid #f2f2f2;
  border-radius: 14px;
`;

const SuccessText = styled.div`
  height: 21px;
  margin-top: 60px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: #000000;
`;
export const SuccessModal = (
  props: DialogProps & { onClickConfirm: () => void; content: string },
) => {
  const { t } = useTranslation();
  const { content, onClickConfirm, ...dialogProps } = props;
  return (
    <Dialog
      sx={{
        [`.${paperClasses.root}`]: {
          width: '100%',
          height: '100%',
          boxShadow: 'unset',
          backgroundColor: 'transparent',
        },
      }}
      {...dialogProps}>
      <SuccessModalContent>
        <SuccessText>{content}</SuccessText>
        <BlueRoundedButton marginTop="24px" onClick={onClickConfirm}>
          {t('common.button.confirm')}
        </BlueRoundedButton>
      </SuccessModalContent>
    </Dialog>
  );
};
